module.exports = __webpack_public_path__ + "static/img/huawei.85bf19f.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/huawei.png
// module id = /4Al
// module chunks = 2